import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardHeader,
  Grid,
  Snackbar,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import useApi from "../../../../hooks/api";
import useAuth from "../../../../hooks/auth";
import Alert from "../../../ui/alert";
import { Switch } from "../../../ui/form_fields";
import Page from "../../../ui/page";

const Config = () => {
  const { patch } = useApi();
  const [updated, setUpdated] = useState(false);
  const { user, setAuth } = useAuth();
  const configs = user?.configs;

  const handleSubmit = (values, actions) => {
    actions.setSubmitting(true);

    patch(`/users/${user.id}/update_config`, values)
      .then((response) => {
        setAuth(response);
        setUpdated(true);
        actions.setSubmitting(false);
      })
      .catch((err) =>
        alert(
          "Não conseguimos processar sua solicitação. Tente novamente mais tarde."
        )
      );
  };

  return (
    <Page headerProps={{ icon: "cog", title: "Configurações" }}>
      <Card elevation={4}>
        <CardHeader
          title="Personalize sua experiência na plataforma"
          disableTypography
          style={{ fontSize: "16px", fontWeight: "bold" }}
        />

        <div className="panel-body">
          <Formik initialValues={configs} onSubmit={handleSubmit}>
            {(formikProps) => (
              <Form>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="config-filters"
                    id="panel1a-header"
                  >
                    Filtros
                  </AccordionSummary>

                  <AccordionDetails>
                    <Grid container spacing={4} style={{ paddingTop: 0 }}>
                      <Grid item xs={12} md={3}>
                        <Field
                          label="Filtros básicos"
                          name="search.basic.show"
                          component={Switch}
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <Field
                          label="Filtros avançados"
                          name="search.advanced.show"
                          component={Switch}
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <Field
                          label="Filtros específicos"
                          name="search.specific.show"
                          component={Switch}
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <Button
                          style={{ width: "100%" }}
                          onClick={formikProps.submitForm}
                          className="btn btn-primary btn-mercatorio"
                          disabled={
                            !formikProps.dirty || formikProps.isSubmitting
                          }
                        >
                          {formikProps.isSubmitting
                            ? "Atualizando"
                            : "Atualizar"}
                        </Button>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Form>
            )}
          </Formik>
        </div>
      </Card>

      <Snackbar
        open={updated}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setUpdated(false)}
      >
        <Alert message="Configurações atualizadas com sucesso!" />
      </Snackbar>
    </Page>
  );
};

export default Config;
